<div class="modal-body">
  <button id="close-button" class="material-symbols-outlined bold clickable" (click)="closeModal()">close</button>
  <markdown [data]="data"></markdown>
</div>
